import { render, staticRenderFns } from "./CStyle.vue?vue&type=template&id=5877ad0c&"
import script from "./CStyle.vue?vue&type=script&lang=js&"
export * from "./CStyle.vue?vue&type=script&lang=js&"
import style0 from "./CStyle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports